export default {
      id: "logo-cb-white-large-usage",
      viewBox: "0 0 47 30",
      url: "/assets/svg/" + "sprite.svg#logo-cb-white-large-usage",
      toString: function () {
        return this.url;
      }
    }